import React from "react";

export default function LeasePrice(props) {
  const {leasePrice} = props;

  return (
    <React.Fragment>
      <dl className={'auctionPrice__item'}>
        <dt className={'auctionPrice__title'}>毎月の支払い額</dt>
        <dd className={'auctionPrice__price'}>
          <span className={'auctionPrice__price--strong auctionPrice__price--large'}>
            {leasePrice}
          </span>
          円(税込)〜
        </dd>
      </dl>
    </React.Fragment>
  )
}
